import { useMutation } from "@apollo/client"
import { SET_USER_ACTION_AS_READ } from "../graphql/mutations/setUserActionAsRead"
import { GET_ACTIVITY_LOG } from "../graphql/queries/getActivityLog"

export const useSetUserLogAsRead = ({ onCompleted, onError }: { onCompleted: any; onError: any }) => {
  const [setUserLogAsRead, { client, data, loading }] = useMutation(SET_USER_ACTION_AS_READ, {
    onCompleted: onCompleted,
    onError: onError,
    refetchQueries: [GET_ACTIVITY_LOG],
  })

  return { setUserLogAsRead, data, loading, client }
}
